var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mt-3",attrs:{"no-body":""}},[_c('b-card-header',[_c('h4',[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('b-card-body',[_c('div',{staticClass:"mt-5",staticStyle:{"position":"relative"}},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }